module.exports = __webpack_public_path__ + "static/media/sprite.93a23230.svg";